/**
 * @generated SignedSource<<ddfb2098093ddc456421158a5fb69b69>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ApprovalsPageQuery$variables = {};
export type ApprovalsPageQuery$data = {
  readonly adminPendingAccounts: ReadonlyArray<{
    readonly createdAt: any;
    readonly email: string;
    readonly emailVerified: boolean;
    readonly id: string;
    readonly name: string;
    readonly restaurantName: string | null;
    readonly restaurantSlug: string | null;
  }>;
};
export type ApprovalsPageQuery = {
  response: ApprovalsPageQuery$data;
  variables: ApprovalsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PendingAccount",
    "kind": "LinkedField",
    "name": "adminPendingAccounts",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailVerified",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "restaurantName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "restaurantSlug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ApprovalsPageQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ApprovalsPageQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "523e3189e3a8c2341b6cb5aa63ace20f",
    "id": null,
    "metadata": {},
    "name": "ApprovalsPageQuery",
    "operationKind": "query",
    "text": "query ApprovalsPageQuery {\n  adminPendingAccounts {\n    id\n    name\n    email\n    emailVerified\n    restaurantName\n    restaurantSlug\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "1d55c4ce0981495ea8b3ad274cf37358";

export default node;
